import React from 'react';
import Head from 'next/head';
import { useTranslation } from 'next-i18next';
import { GetServerSidePropsContext } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { API, APIRoutes, BANNER_TARGETS } from '@utils/api';
import MainBanner from '@components/PageBanner';

import EmployersList from '@components/EmployersList';
import HorizontalRule from '@pages/employers/style';

function EmployersPage({ banners, employers }) {
  const { t } = useTranslation('employers');

  return (
    <>
      <Head>
        <title>{t('employers')}</title>
        <meta property="og:title" content="Employers" />
        <meta property="og:image" content={`${process.env.NEXT_PUBLIC_PORTAL_URL}/images/lodz.png`} />
        <meta property="og:image:secure_url" content={`${process.env.NEXT_PUBLIC_PORTAL_URL}/images/lodz.png`} />
        <meta property="og:image:width" content="200" />
        <meta property="og:image:height" content="279" />
        <meta property="og:description" content={`${process.env.NEXT_PUBLIC_PORTAL_URL}`} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={`${process.env.NEXT_PUBLIC_PORTAL_URL}/pracodawca`} />
      </Head>

      <MainBanner bannerItems={banners} />
      <HorizontalRule />
      <EmployersList employers={employers} />
    </>
  );
}

export async function getServerSideProps({ locale, query }: GetServerSidePropsContext) {
  try {
    const {
      data: { banners },
    } = await API.get(APIRoutes.banners(BANNER_TARGETS.EMPLOYER));

    const { data: employers } = await API.get(APIRoutes.employers({ page: query.page || 1, ...query }));

    return {
      props: {
        ...(await serverSideTranslations(locale, [
          'common',
          'homepage',
          'navbar',
          'footer',
          'offers',
          'employers',
          'bottomBanner',
        ])),
        banners,
        employers,
      },
    };
  } catch (error) {
    return { props: {} };
  }
}
export default EmployersPage;
